module.exports = __webpack_public_path__ + "static/media/01C.033a4cfb.png";